import { render, staticRenderFns } from "./DashChartLabels.vue?vue&type=template&id=5a259498&"
import script from "./DashChartLabels.vue?vue&type=script&lang=js&"
export * from "./DashChartLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports